export const getCurrentDateTime = () => {
  const now = new Date();
  const dateOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
  const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: false };

  const dateStr = now
    .toLocaleDateString("en-US", dateOptions)
    .replace(/\//g, "/");
  const timeStr = now.toLocaleTimeString("th-TH", timeOptions);

  return `${dateStr} ${timeStr}`;
};
